import { type z } from 'zod';

import { CreateSentenceSchema } from './create-sentence.dto';

export const UpdateSentenceSchema = CreateSentenceSchema.partial();

export type IUpdateSentenceDto = z.infer<typeof UpdateSentenceSchema>;
